import { createStore, applyMiddleware, Store, combineReducers } from "redux";
import thunk from "redux-thunk";
import reducer from "./reducer";
import searchReducer from './searchReducer';
import {StoreState, ReduxAction, DispatchType} from '../type.d';

const rootReducer = combineReducers({reducer, searchReducer})

export const store: Store<StoreState, ReduxAction> & {
  dispatch: DispatchType
} = createStore(rootReducer, applyMiddleware(thunk))
